import { createSlice } from '@reduxjs/toolkit';
import lineEndpoint from 'app/api/services/lineEndpoint';
import { errorHandler } from 'app/utils/errorHandler';
import userEndpoints from '../../api/services/userEndpoints';

const initialState = {
    grants: [],
    services: [],
    allLines: [],
    allSubstituteConductors: null,
    situations: [],
    selected: null,
    selectedLineId: null,
    selectedLinesRequest: [],
    selectedLinesRequestIds: [],
    selectedEquipmentType: null,
    selectedEquipmentClassification: null,
    selectedSubstituteEquipmentType: null,
    selectedSubstituteEquipmentClassification: null,
    lineScheduleBoard: null,
    schedulesStore: [],
    permissionaries: null,
    itineraries: [],
    itineraryTypes: [],
    selectedPermissionary: null,
    permissionaryConductors: [],
    permissionaryRefData: [],
    lineAdictives: [],
    lineVehicles: [],
    lineTransfers: [],
    lineLocations: [],
    lineSections: [],
    duplicatedRegistry: {},
    fares: null,
    permissionaryCepe: null,
    permissionaryInspectedVehicles: null,
    conductorDefaultExpirationDate: null,
    contractType: [],
    servicesType: [],
    isStrip: false,
    lineSecretary: null,
    parentLine: null,
};

const lineSlice = createSlice({
    name: 'line',
    initialState,
    reducers: {
        setGrants(state, action) {
            state.grants = action.payload;
        },
        setServices(state, action) {
            state.services = action.payload;
        },
        clearGrants(state, action) {
            state.grants = initialState.grants;
        },
        clearServices(state, action) {
            state.services = initialState.services;
        },
        setAllLines(state, action) {
            state.allLines = action.payload;
        },
        clearAllLines(state, action) {
            state.allLines = initialState.allLines;
        },
        setSelectedLine(state, action) {
            state.selected = action.payload;
        },
        clearSelectedLine(state, action) {
            state.selected = initialState.selected;
        },
        setSelectedLineId(state, action) {
            state.selectedLineId = action.payload;
        },
        clearSelectedLineId(state, action) {
            state.selectedLineId = initialState.selectedLineId;
        },
        setSelectedLinesRequest(state, action) {
            state.selectedLinesRequest = action.payload;
        },
        clearSelectedLinesRequest(state, action) {
            state.selectedLinesRequest = initialState.selectedLinesRequest;
        },
        setSelectedLinesRequestIds(state, action) {
            state.selectedLinesRequestIds = action.payload;
        },
        clearSelectedLinesRequestIds(state, action) {
            state.selectedLinesRequestIds = initialState.selectedLinesRequest;
        },
        setSelectedEquipmentType(state, action) {
            state.selectedEquipmentType = action.payload;
        },
        setSelectedEquipmentClassification(state, action) {
            state.selectedEquipmentClassification = action.payload;
        },
        clearSelectedEquipmentType(state, action) {
            state.selectedEquipmentType = initialState.selectedLineId;
        },
        clearSelectedEquipmentClassification(state, action) {
            state.selectedEquipmentClassification = initialState.selectedLineId;
        },
        setSelectedSubstituteEquipmentType(state, action) {
            state.selectedSubstituteEquipmentType = action.payload;
        },
        setSelectedSubstituteEquipmentClassification(state, action) {
            state.selectedSubstituteEquipmentClassification = action.payload;
        },
        clearSelectedSubstituteEquipmentType(state, action) {
            state.selectedSubstituteEquipmentType = initialState.selectedLineId;
        },
        clearSelectedSubstituteEquipmentClassification(state, action) {
            state.selectedSubstituteEquipmentClassification = initialState.selectedLineId;
        },
        setLineScheduleBoard(state, action) {
            state.lineScheduleBoard = action.payload;
        },
        clearLineScheduleBoard(state, action) {
            state.lineScheduleBoard = initialState.lineScheduleBoard;
        },
        setSchedulesStore(state, action) {
            state.schedulesStore = action.payload;
        },
        clearSchedulesStore(state, action) {
            state.schedulesStore = initialState.schedulesStore;
        },
        setPermissionaries(state, action) {
            state.permissionaries = action.payload;
        },
        clearPermissionaries(state, action) {
            state.permissionaries = initialState.permissionaries;
        },
        setItinerariesStore(state, action) {
            state.itineraries = action.payload;
        },
        clearItineraries(state, action) {
            state.itineraries = initialState.itineraries;
        },
        setItineraryTypes(state, action) {
            state.itineraryTypes = action.payload;
        },
        clearItineraryTypes(state, action) {
            state.itineraryTypes = initialState.itineraryTypes;
        },
        setSelectedPermissionary(state, action) {
            state.selectedPermissionary = action.payload;
        },
        clearSelectedPermissionary(state, action) {
            state.selectedPermissionary = initialState.selectedPermissionary;
        },
        setLineVehicles(state, action) {
            state.lineVehicles = action.payload;
        },
        clearLineVehicles(state, action) {
            state.lineVehicles = initialState.lineVehicles;
        },
        setPermissionaryConductors(state, action) {
            state.permissionaryConductors = action.payload;
        },
        clearPermissionaryConductors(state, action) {
            state.permissionaryConductors = initialState.permissionaryConductors;
        },
        setAllSubstituteConductors(state, action) {
            state.allSubstituteConductors = action.payload;
        },
        clearAllSubstituteConductors(state, action) {
            state.allSubstituteConductors = initialState.allSubstituteConductors;
        },
        setPermissionaryRefData(state, action) {
            state.permissionaryRefData = action.payload;
        },
        clearPermissionaryRefData(state, action) {
            state.permissionaryRefData = initialState.permissionaryRefData;
        },
        setLineAdictives(state, action) {
            state.lineAdictives = action.payload;
        },
        clearLineAdictives(state, action) {
            state.lineAdictives = initialState.lineAdictives;
        },
        setLineTransfers(state, action) {
            state.lineTransfers = action.payload;
        },
        clearLineTransfers(state, action) {
            state.lineTransfers = initialState.lineTransfers;
        },
        setFares(state, action) {
            state.fares = action.payload;
        },
        clearFares(state, action) {
            state.fares = initialState.fares;
        },
        setSituations(state, action) {
            state.situations = action.payload;
        },
        clearSituations(state, action) {
            state.situations = initialState.situations;
        },
        setLineLocations(state, action) {
            state.lineLocations = action.payload;
        },
        clearLineLocations(state, action) {
            state.lineLocations = initialState.lineLocations;
        },
        setLineSections(state, action) {
            state.lineSections = action.payload;
        },
        clearLineSections(state, action) {
            state.lineSections = initialState.lineSections;
        },
        setDuplicatedRegistry(state, action) {
            state.duplicatedRegistry = action.payload;
        },
        clearDuplicatedRegistry(state, action) {
            state.duplicatedRegistry = initialState.duplicatedRegistry;
        },
        setPermissionaryCepe(state, action) {
            state.permissionaryCepe = action.payload;
        },
        clearPermissionaryCepe(state, action) {
            state.permissionaryCepe = initialState.permissionaryCepe;
        },
        setPermissionaryVehicles(state, action) {
            state.permissionaryInspectedVehicles = action.payload;
        },
        clearPermissionaryVehicles(state, action) {
            state.permissionaryInspectedVehicles = initialState.permissionaryInspectedVehicles;
        },
        setConductorDefaultExpirationDate(state, action) {
            state.conductorDefaultExpirationDate = action.payload;
        },
        setContractType(state, action) {
            state.contractType = action.payload;
        },
        clearContractType(state, action) {
            state.contractType = initialState.contractType;
        },
        setServicesType(state, action) {
            state.servicesType = action.payload;
        },
        clearServicesType(state, action) {
            state.servicesType = initialState.servicesType;
        },
        setIsStrip(state, action) {
            state.isStrip = action.payload;
        },
        setLineSecretary(state, action) {
            state.lineSecretary = action.payload;
        },
        setParentLine(state, action) {
            state.parentLine = action.payload;
        },
    },
});

export const fetchAllLines =
    (filter = {}, iStrip = false) =>
    async (dispatch) => {
        try {
            const response = await lineEndpoint.getLines({ page: 0, size: 9999, request: filter });
            const { content } = response.data;
            dispatch(setAllLines(content));
            if (!iStrip) dispatch(setSelectedLineId(content[0].cdLinha));
        } catch (error) {
            errorHandler(error.response?.status, error.response?.data?.message);
        }
    };

export const fetchLine = (cdLinha) => async (dispatch) => {
    try {
        const response = await lineEndpoint.getLine(cdLinha);
        dispatch(setSelectedLine(response.data));
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
};

export const fetchGrants = () => async (dispatch) => {
    try {
        const response = await lineEndpoint.getGrants();
        dispatch(setGrants(response.data));
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
};

export const fetchSituations = () => async (dispatch) => {
    try {
        const response = await lineEndpoint.getSituations();
        dispatch(setSituations(response.data));
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
};

/**
 * Método para buscar localidades das linhas para os itinerários, e adicionar ao estado do Redux
 * @type LineLocation
 * @returns {(function(*): Promise<void>)|*}
 */
export const fetchLocations = () => async (dispatch) => {
    try {
        const response = await lineEndpoint.getLocations();
        dispatch(setLineLocations(response.data));
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
};

export const fetchSections = () => async (dispatch) => {
    try {
        const response = await lineEndpoint.getSections();
        dispatch(setLineSections(response.data));
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
};

export const fetchItineraryTypes = () => async (dispatch) => {
    try {
        const response = await lineEndpoint.getItineraryTypes();
        dispatch(setItineraryTypes(response.data));
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
};

export const fetchServices = () => async (dispatch) => {
    try {
        const response = await lineEndpoint.getServices();
        dispatch(setServices(response.data));
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
};

export const fetchAllPermissionaries = (params) => async (dispatch) => {
    try {
        let response = {};

        response = await lineEndpoint.getPermissionaries(params);
        dispatch(setPermissionaries(response.data));
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
};

export const fetchPermissionary = (cdPermissionario) => async (dispatch) => {
    try {
        const response = await lineEndpoint.getPermissionary(cdPermissionario);
        dispatch(setSelectedPermissionary(response.data));
        // dispatch(setSelectedPermissionary(permissionarioMock));
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
};

export const fetchPermissionaryVehicles = (params) => async (dispatch) => {
    try {
        const response = await lineEndpoint.getVehiclesByDocument(params);
        dispatch(setPermissionaryVehicles(response.data));
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
};

export const fetchPermissionaryConductors = (permiId) => async (dispatch) => {
    try {
        const response = await lineEndpoint.getSubstituteConductorsByPermissionary(permiId);
        if (response.status === 200) {
            dispatch(setPermissionaryConductors(response?.data));
        }
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
};

export const fetchSubstituteConductors = (params) => async (dispatch) => {
    try {
        const response = await lineEndpoint.getSubstituteConductors(params);
        dispatch(setAllSubstituteConductors(response.data));
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
};

export const fetchAllFares = (params) => async (dispatch) => {
    try {
        const response = await lineEndpoint.getFares(params);
        // const { content } = response.data;
        dispatch(setFares(response.data));
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
};

export const fetchLineTransfers = (params) => async (dispatch) => {
    try {
        const response = await lineEndpoint.getTransfers(params);
        dispatch(setLineTransfers(response.data));
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
};

export const fetchCepe = (cdPermissionario) => async (dispatch) => {
    try {
        const response = await lineEndpoint.getCepe(cdPermissionario);
        dispatch(setPermissionaryCepe(response.data));
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
};

export const fetchPermissionaryRefData = () => async (dispatch) => {
    try {
        const response = await lineEndpoint.getDateReference();
        dispatch(setPermissionaryRefData(response.data));
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
};

export const fetchContractType = () => async (dispatch) => {
    try {
        const response = await lineEndpoint.getContractType();
        dispatch(setContractType(response.data));
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
};

export const fetchServicesType = () => async (dispatch) => {
    try {
        const response = await lineEndpoint.getServiceType();
        dispatch(setServicesType(response.data));
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
};

export const fetchLineSecretary = () => async (dispatch) => {
    try {
        const response = await userEndpoints.getLineSecretary();
        dispatch(setLineSecretary(response.data));
    } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
    }
};

export const {
    setGrants,
    clearGrants,
    setServices,
    clearServices,
    setAllLines,
    clearAllLines,
    setSelectedLine,
    clearSelectedLine,
    setSelectedLineId,
    clearSelectedLineId,
    setSelectedLinesRequest,
    clearSelectedLinesRequest,
    setSelectedLinesRequestIds,
    clearSelectedLinesRequestIds,
    setSelectedEquipmentType,
    clearSelectedEquipmentType,
    setSelectedSubstituteEquipmentType,
    clearSelectedSubstituteEquipmentType,
    setSelectedEquipmentClassification,
    clearSelectedEquipmentClassification,
    setSelectedSubstituteEquipmentClassification,
    clearSelectedSubstituteEquipmentClassification,
    setLineScheduleBoard,
    clearLineScheduleBoard,
    setSchedulesStore,
    clearSchedulesStore,
    setPermissionaries,
    clearPermissionaries,
    setSelectedPermissionary,
    clearSelectedPermissionary,
    setLineVehicles,
    clearLineVehicles,
    setPermissionaryConductors,
    clearPermissionaryConductors,
    setAllSubstituteConductors,
    clearAllSubstituteConductors,
    setPermissionaryRefData,
    clearPermissionaryRefData,
    setLineAdictives,
    clearLineAdictives,
    setLineTransfers,
    clearLineTransfers,
    setFares,
    clearFares,
    setItinerariesStore,
    clearItineraries,
    setSituations,
    clearSituations,
    setItineraryTypes,
    clearItineraryTypes,
    setLineLocations,
    clearLineLocations,
    setLineSections,
    clearLineSections,
    setDuplicatedRegistry,
    clearDuplicatedRegistry,
    setPermissionaryCepe,
    clearPermissionaryCepe,
    setPermissionaryVehicles,
    clearPermissionaryVehicles,
    setConductorDefaultExpirationDate,
    setContractType,
    clearContractType,
    setServicesType,
    clearServicesType,
    setIsStrip,
    setLineSecretary,
    setParentLine,
} = lineSlice.actions;
export default lineSlice;
